import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import { GenericApiErrors, LoginPayload } from './EmailSettingsTypes'

export const getUserEmail = async () => {
  try {
    const result = await http.get('/v2/recebimento/email-setting')
    return parseGoodResponse<string>(result.data.email)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const login = async (payload: LoginPayload) => {
  try {
    const result = await http.post('/v2/recebimento/email-setting', { code: payload.codeResponse })
    return parseGoodResponse<string>(result.data.email)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}
